<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.unidade"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(conectasusCentroCustoDescricao)="{item}">
                <template v-if="item.conectasusCentroCustoDescricao">
                    {{ item.conectasusCentroCustoDescricao }}
                </template>

                <rkm-button
                    v-else
                    @click="$refs.ModalVinculoConectaSusCentroCusto.open(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-unidade"
                    color="primary"
                    small
                >
                    Vincular centro de custo
                </rkm-button>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-unidade"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-web-service-almoxarifado-cliente-unidade"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalVinculoConectaSusCentroCusto
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalVinculoConectaSusCentroCusto"
        />
    </div>
</template>

<script>
// Components.
import ModalVinculoConectaSusCentroCusto from './components/vinculo-conecta-sus-centro-custo/Modal'

// Mixins.
import {error, repository} from '@/mixins'

export default {
    components: {ModalVinculoConectaSusCentroCusto},
    created() {
        this.repositories = {
            unidade: this.getConectaSusRepository('webService.almoxarifado.cliente.unidade'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'unidade.nome', searchable: true, sortable: true},
            {key: 'cnes', label: 'CNES', name: 'unidade.cnes', searchable: true, sortable: true},
            {
                key: 'conectasusCentroCustoDescricao',
                label: 'Centro de custo (ConectaSUS)',
                name: 'conectasusCentroCustoDescricao',
                searchable: true,
                sortable: true
            },
            {key: 'isAlmoxarifado', label: 'Almoxarifado?', name: 'isAlmoxarifado', searchable: true, sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-almoxarifado-cliente-unidade-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.unidade.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>